import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2382866d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-block" }

import { ref, watch } from 'vue';
import { OioModal, OioButton, OioMessage } from '@kunlun/vue-ui-antd';
import { executeServerAction } from '@kunlun/dependencies';

interface IProps {
  formData: any;
  change: (val: any) => void;
  currentViewActions: any[];
  setFormLoading: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DealerCreditProfileTabs',
  props: {
    formData: null,
    change: null,
    currentViewActions: null,
    setFormLoading: null
  },
  setup(__props: any) {

const props = __props as { formData: any, change: (val: any) => void, currentViewActions: any[], setFormLoading: () => void }



const activeKey = ref('');
const saveKey = ref('');
const tablist = ref<any>([]);
const open = ref(false);
const loading = ref(false);
const currentValue = ref();
const changeLoading = ref(false);

const change = (val) => {
  open.value = true;
  currentValue.value = val;
};

const handleSave = async () => {
  try {
    loading.value = true;
    const action = props.currentViewActions.find((a) => a.label === '更新');
    await executeServerAction(action, { ...props.formData });
    OioMessage.success('保存成功');
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const handleClose = () => {
  activeKey.value = saveKey.value;
  open.value = false;
};

const handleOk = async () => {
  saveKey.value = currentValue.value;
  props.change(currentValue.value);

  changeLoading.value = true;

  await new Promise((resolve) => setTimeout(resolve, 1500));
  open.value = false;
  // props.setFormLoading(true);

  changeLoading.value = false;
};

const getTablist = () => {
  const tabs = props?.formData?.deliPlatformDisCreditAccountProxyList as any[];
  const list = tabs.map((i) => {
    return { name: i.bizName, id: i.id };
  });
  if (list && Array.isArray(list)) {
    activeKey.value = list[0].id;
    saveKey.value = list[0].id;
    return list;
  }
  return [];
};

const stopWatch = watch(
  () => props.formData,
  (val) => {
    if (val?.deliPlatformDisCreditAccountProxyList) {
      tablist.value = getTablist();
      stopWatch();
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
      onTabClick: change
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tablist.value, (item) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.id,
            tab: item.name
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: handleSave,
                loading: loading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 2
          }, 1032, ["tab"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(_unref(OioModal), {
      title: "提示",
      width: "small",
      visible: open.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event)),
      maskClosable: false,
      enterText: "切换",
      "confirm-loading": changeLoading.value,
      cancelCallback: handleClose,
      enterCallback: handleOk
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 是否切换！如有修改，请先点击下方保存按钮 ")
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"])
  ]))
}
}

})